module.exports = __webpack_public_path__ + "74ef3c7058b130bdfb7f84130f37906e.svg";